import { useNavigate } from "react-router";

import { ChevronLeftIcon } from "@/components/atoms/icons";
import { Button } from "@/components/atoms/ui/button";

export type GoBackProps = {
  label?: string;
  onBack?: () => void;
};

const GoBack = ({ label = "Volver", onBack }: GoBackProps) => {
  const navigate = useNavigate();
  const handleGoBack = () => {
    if (typeof onBack !== "undefined") {
      onBack();
    } else {
      navigate(-1);
    }
  };
  return (
    <Button
      className="flex items-center gap-1 px-0 text-base font-bold text-[#9E9E9E]"
      variant="link"
      onClick={handleGoBack}
    >
      <ChevronLeftIcon /> {label}
    </Button>
  );
};

export default GoBack;
